
export enum AlertType {
    SUCCESS = 0,
    INFO = 1,
    ERROR = 2,
}

export interface AlertDescription {
    id: string,
    title?: string,
    message: string,
    type: AlertType,
}

export interface AlertProviderProps {
    children?: React.ReactNode,
}

export interface AlertContextType {
    alerts: AlertDescription[]
    show: (message: string, title?: string, type?: AlertType) => void,
    success: (message: string, title?: string) => void,
    info: (message: string, title?: string) => void,
    error: (message: string, title?: string) => void,
}